import {observer} from "mobx-react";
import {FormControl, Typography} from "../../../../../common/components/libs";
import React from "react";
import {useTranslation} from "react-i18next";
import style from "./../style.module.css";
import {FormControlLabel, InputLabel, OutlinedInput, Select, Switch, MenuItem} from "@material-ui/core";
import { changeEventHandlerDecorator} from "../../../../../common/libs";
import {useStores} from "../../../../../hooks";
import {
    MenuCategoryWorkingScheduleDay, MenuCategoryWorkingScheduleDaySlot,
} from "../../../../../services/menu/models";

interface CategoryWorkingSlotProps {
    item: MenuCategoryWorkingScheduleDaySlot,
    daySchedule: MenuCategoryWorkingScheduleDay,
    updateValue: (t: MenuCategoryWorkingScheduleDay) => void;
}


const CategoryWorkingSlot = observer((props: CategoryWorkingSlotProps) => {
    const {t} = useTranslation(["general", "menu"]);
    const {item, daySchedule} = props;
    const slots = daySchedule.slots;
    const slot = slots[0];

    const time = [
        {hour: "00", min: "00"}, {hour: "00", min: "15"}, {hour: "00", min: "30"}, {hour: "00", min: "45"}, {hour: "00", min: "59"},
        {hour: "01", min: "00"}, {hour: "01", min: "15"}, {hour: "01", min: "30"}, {hour: "01", min: "45"}, {hour: "01", min: "59"},
        {hour: "02", min: "00"}, {hour: "02", min: "15"}, {hour: "02", min: "30"}, {hour: "02", min: "45"}, {hour: "02", min: "59"},
        {hour: "03", min: "00"}, {hour: "03", min: "15"}, {hour: "03", min: "30"}, {hour: "03", min: "45"}, {hour: "03", min: "59"},
        {hour: "04", min: "00"}, {hour: "04", min: "15"}, {hour: "04", min: "30"}, {hour: "04", min: "45"}, {hour: "04", min: "59"},
        {hour: "05", min: "00"}, {hour: "05", min: "15"}, {hour: "05", min: "30"}, {hour: "05", min: "45"}, {hour: "05", min: "59"},
        {hour: "06", min: "06"}, {hour: "06", min: "15"}, {hour: "06", min: "30"}, {hour: "06", min: "45"}, {hour: "06", min: "59"},
        {hour: "07", min: "00"}, {hour: "07", min: "15"}, {hour: "07", min: "30"}, {hour: "07", min: "45"}, {hour: "07", min: "59"},
        {hour: "08", min: "00"}, {hour: "08", min: "15"}, {hour: "08", min: "30"}, {hour: "08", min: "45"}, {hour: "08", min: "59"},
        {hour: "09", min: "00"}, {hour: "09", min: "15"}, {hour: "09", min: "30"}, {hour: "09", min: "45"}, {hour: "09", min: "59"},
        {hour: "10", min: "00"}, {hour: "10", min: "15"}, {hour: "10", min: "30"}, {hour: "10", min: "45"}, {hour: "10", min: "59"},
        {hour: "11", min: "00"}, {hour: "11", min: "15"}, {hour: "11", min: "30"}, {hour: "11", min: "45"}, {hour: "11", min: "59"},
        {hour: "12", min: "00"}, {hour: "12", min: "15"}, {hour: "12", min: "30"}, {hour: "12", min: "45"}, {hour: "12", min: "59"},
        {hour: "13", min: "00"}, {hour: "13", min: "15"}, {hour: "13", min: "30"}, {hour: "13", min: "45"}, {hour: "13", min: "59"},
        {hour: "14", min: "00"}, {hour: "14", min: "15"}, {hour: "14", min: "30"}, {hour: "14", min: "45"}, {hour: "14", min: "59"},
        {hour: "15", min: "00"}, {hour: "15", min: "15"}, {hour: "15", min: "30"}, {hour: "15", min: "45"}, {hour: "15", min: "59"},
        {hour: "16", min: "00"}, {hour: "16", min: "15"}, {hour: "16", min: "30"}, {hour: "16", min: "45"}, {hour: "16", min: "59"},
        {hour: "17", min: "00"}, {hour: "17", min: "15"}, {hour: "17", min: "30"}, {hour: "17", min: "45"}, {hour: "17", min: "59"},
        {hour: "18", min: "00"}, {hour: "18", min: "15"}, {hour: "18", min: "30"}, {hour: "18", min: "45"}, {hour: "18", min: "59"},
        {hour: "19", min: "00"}, {hour: "19", min: "15"}, {hour: "19", min: "30"}, {hour: "19", min: "45"}, {hour: "19", min: "59"},
        {hour: "20", min: "00"}, {hour: "20", min: "15"}, {hour: "20", min: "30"}, {hour: "20", min: "45"}, {hour: "20", min: "59"},
        {hour: "21", min: "00"}, {hour: "21", min: "15"}, {hour: "21", min: "30"}, {hour: "21", min: "45"}, {hour: "21", min: "59"},
        {hour: "22", min: "00"}, {hour: "22", min: "15"}, {hour: "22", min: "30"}, {hour: "22", min: "45"}, {hour: "22", min: "59"},
        {hour: "23", min: "00"}, {hour: "23", min: "15"}, {hour: "23", min: "30"}, {hour: "23", min: "45"}, {hour: "23", min: "59"},

    ]


    return (<>
            <div className={style.time}>
                <FormControl fullWidth variant="outlined" className={style.select}>
                    <InputLabel htmlFor="menuCategorySchedule">
                        {t("menu:showFrom")}
                    </InputLabel>
                    <Select
                        value={`${slot.fromHour}:${slot.fromMinute}`}
                        onChange={changeEventHandlerDecorator(function (workingSchedule: string): void {
                            props.updateValue({
                                ...daySchedule,
                                slots: [
                                    {
                                        fromHour: parseInt(workingSchedule.split(":")[0]),
                                        fromMinute: parseInt(workingSchedule.split(":")[1]),
                                        toHour: item.toHour,
                                        toMinute: item.toMinute
                                    }
                                ]
                            });
                        })
                        }
                        input={<OutlinedInput
                            labelWidth={80}
                        />}
                    >
                        {
                            time.map(index => {
                                const hour = parseInt(index.hour);
                                const min = parseInt(index.min);
                                return (
                                    <MenuItem value={`${hour}:${min}`} key={`${hour}:${min}`}>
                                        {index.hour} : {index.min}
                                    </MenuItem>
                                )
                            })
                        }

                    </Select>
                </FormControl>
                <FormControl fullWidth variant="outlined" className={style.select}>
                    <InputLabel htmlFor="menuCategorySchedule">
                        {t("menu:showTo")}
                    </InputLabel>
                    <Select
                        value={`${slot.toHour}:${slot.toMinute}`}
                        onChange={changeEventHandlerDecorator(function (workingSchedule: string): void {
                            props.updateValue({
                                ...daySchedule,
                                slots: [
                                    {
                                        fromHour: item.fromHour,
                                        fromMinute: item.fromMinute,
                                        toHour: parseInt(workingSchedule.split(":")[0]),
                                        toMinute: parseInt(workingSchedule.split(":")[1])
                                    }
                                ]
                            });
                        })
                        }
                        input={<OutlinedInput
                            labelWidth={80}
                        />}
                    >
                        {
                            time.map(index => {
                                const hour = parseInt(index.hour);
                                const min = parseInt(index.min);
                                return (
                                    <MenuItem value={`${hour}:${min}`} key={`${hour}:${min}`}>
                                        {index.hour} : {index.min}
                                    </MenuItem>
                                )
                            })
                        }

                    </Select>
                </FormControl>
            </div>

        </>
    )
})


const MenuCategorySchedule = () => {
    const {t} = useTranslation(["general", "menu"]);
    const {menuStore} = useStores();


    return (
        <div className={style.menuCategorySchedule}>
            <Typography variant={"h5"} className={style.scheduleTitle}>
                {t("menu:menuCategorySchedule")}
            </Typography>
            <div className={style.dayTime}>
                <FormControl>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={menuStore.categoryWorkingSchedule.monday.isEnabled}
                                onChange={(event) => {
                                    menuStore.setMondayCategorySchedule( {
                                        ...menuStore.categoryWorkingSchedule.monday,
                                        isEnabled: event.target.checked
                                    });
                                }}
                                value={menuStore.categoryWorkingSchedule.monday.isEnabled}
                            />
                        }
                        label= {t("menu:orderSettingsPage.monday")}
                    />
                </FormControl>
                {
                    menuStore.categoryWorkingSchedule.monday.isEnabled && menuStore.categoryWorkingSchedule.monday.slots.map(item => {
                        return <CategoryWorkingSlot
                            item={item}
                            daySchedule={menuStore.categoryWorkingSchedule.monday}
                            updateValue={menuStore.setMondayCategorySchedule.bind(menuStore)}
                        />
                    })
                }
            </div>
            <div className={style.dayTime}>
                <FormControl>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={menuStore.categoryWorkingSchedule.tuesday.isEnabled}
                                onChange={(event) => {
                                    menuStore.setTuesdayCategorySchedule({
                                        ...menuStore.categoryWorkingSchedule.tuesday,
                                        isEnabled: event.target.checked
                                    });
                                }}
                                value={menuStore.categoryWorkingSchedule.tuesday.isEnabled}
                            />
                        }
                        label={t("menu:orderSettingsPage.tuesday")}
                    />
                </FormControl>
                {
                    menuStore.categoryWorkingSchedule.tuesday.isEnabled && menuStore.categoryWorkingSchedule.tuesday.slots.map(item => {
                        return <CategoryWorkingSlot
                            item={item}
                            daySchedule={menuStore.categoryWorkingSchedule.tuesday}
                            updateValue={menuStore.setTuesdayCategorySchedule.bind(menuStore)}
                        />
                    })
                }
            </div>
            <div className={style.dayTime}>
                <FormControl>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={menuStore.categoryWorkingSchedule.wednesday.isEnabled}
                                onChange={(event) => {
                                    menuStore.setWednesdayCategorySchedule({
                                        ...menuStore.categoryWorkingSchedule.wednesday,
                                        isEnabled: event.target.checked
                                    });
                                }}
                                value={menuStore.categoryWorkingSchedule.wednesday.isEnabled}
                            />
                        }
                        label={t("menu:orderSettingsPage.wednesday")}
                    />
                </FormControl>
                {
                    menuStore.categoryWorkingSchedule.wednesday.isEnabled && menuStore.categoryWorkingSchedule.wednesday.slots.map(item => {
                        return <CategoryWorkingSlot
                            item={item}
                            daySchedule={menuStore.categoryWorkingSchedule.wednesday}
                            updateValue={menuStore.setWednesdayCategorySchedule.bind(menuStore)}
                        />
                    })
                }
            </div>
            <div className={style.dayTime}>
                <FormControl>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={menuStore.categoryWorkingSchedule.thursday.isEnabled}
                                onChange={(event) => {
                                    menuStore.setThursdayCategorySchedule({
                                        ...menuStore.categoryWorkingSchedule.thursday,
                                        isEnabled: event.target.checked
                                    });
                                }}
                                value={menuStore.categoryWorkingSchedule.thursday.isEnabled}
                            />
                        }
                        label={t("menu:orderSettingsPage.thursday")}
                    />
                </FormControl>
                {
                    menuStore.categoryWorkingSchedule.thursday.isEnabled && menuStore.categoryWorkingSchedule.thursday.slots.map(item => {
                        return <CategoryWorkingSlot
                            item={item}
                            daySchedule={menuStore.categoryWorkingSchedule.thursday}
                            updateValue={menuStore.setThursdayCategorySchedule.bind(menuStore)}
                        />
                    })
                }
            </div>
            <div className={style.dayTime}>
                <FormControl>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={menuStore.categoryWorkingSchedule.friday.isEnabled}
                                onChange={(event) => {
                                    menuStore.setFridayCategorySchedule({
                                        ...menuStore.categoryWorkingSchedule.friday,
                                        isEnabled: event.target.checked
                                    });
                                }}
                                value={menuStore.categoryWorkingSchedule.friday.isEnabled}
                            />
                        }
                        label={t("menu:orderSettingsPage.friday")}
                    />
                </FormControl>
                {
                    menuStore.categoryWorkingSchedule.friday.isEnabled && menuStore.categoryWorkingSchedule.friday.slots.map(item => {
                        return <CategoryWorkingSlot
                            item={item}
                            daySchedule={menuStore.categoryWorkingSchedule.friday}
                            updateValue={menuStore.setFridayCategorySchedule.bind(menuStore)}
                        />
                    })
                }
            </div>
            <div className={style.dayTime}>
                <FormControl>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={menuStore.categoryWorkingSchedule.saturday.isEnabled}
                                onChange={(event) => {
                                    menuStore.setSaturdayCategorySchedule({
                                        ...menuStore.categoryWorkingSchedule.saturday,
                                        isEnabled: event.target.checked
                                    });
                                }}
                                value={menuStore.categoryWorkingSchedule.saturday.isEnabled}
                            />
                        }
                        label={t("menu:orderSettingsPage.saturday")}
                    />
                </FormControl>
                {
                    menuStore.categoryWorkingSchedule.saturday.isEnabled && menuStore.categoryWorkingSchedule.saturday.slots.map(item => {
                        return <CategoryWorkingSlot
                            item={item}
                            daySchedule={menuStore.categoryWorkingSchedule.saturday}
                            updateValue={menuStore.setSaturdayCategorySchedule.bind(menuStore)}
                        />
                    })
                }
            </div>
            <div className={style.dayTime}>
                <FormControl>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={menuStore.categoryWorkingSchedule.sunday.isEnabled}
                                onChange={(event) => {
                                    menuStore.setSundayCategorySchedule({
                                        ...menuStore.categoryWorkingSchedule.sunday,
                                        isEnabled: event.target.checked
                                    });
                                }}
                                value={menuStore.categoryWorkingSchedule.sunday.isEnabled}
                            />
                        }
                        label={t("menu:orderSettingsPage.sunday")}
                    />
                </FormControl>
                {
                    menuStore.categoryWorkingSchedule.sunday.isEnabled && menuStore.categoryWorkingSchedule.sunday.slots.map(item => {
                        return <CategoryWorkingSlot
                            item={item}
                            daySchedule={menuStore.categoryWorkingSchedule.sunday}
                            updateValue={menuStore.setSundayCategorySchedule.bind(menuStore)}
                        />
                    })
                }
            </div>
        </div>
    )
}

export default observer(MenuCategorySchedule);
